import { Box, Stack } from '@mui/material';

import AudioItem from './AudioItem';

export const AudioContent = ({ref, mediaData, boxRef,hideDelete }: any) => {
  return (
    <Box flexDirection={'column'} sx={{ overflowY: 'auto' }} height={'calc(100% - 3.2rem)'} ref={boxRef}>
      <Stack
        sx={{
          height: '100%',
          width: '100%',
          overflow: 'hidden',
        }}>
        <Stack
          direction='column'
          alignItems={'flex-start'}
          justifyContent={'flex-start'}
          sx={{ overflowY: 'auto', width: '100%', height: '60vh', position: 'relative' }}>

              <Box  width={'100%'} display={'flex'}>
                <AudioItem ref={ref} hideDelete={hideDelete} item={mediaData.src}  />{' '}
              </Box>

        </Stack>
      </Stack>
    </Box>
  );
};
